<template>
  <div class="comment">
    <div class="search-header">
      <div class="content">
        <el-input
          v-model="searchParams.keyword"
          size="small"
          placeholder="输入消息标题模糊查询"
          class="input-with-select"
          clearable
          v-noEmoji
          maxlength="45"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        >
          <el-button slot="append" @click="handleSearch" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <ContentBox class="content-list">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="全部消息" name="2"></el-tab-pane>
        <el-tab-pane label="未读消息" name="0"></el-tab-pane>
        <el-tab-pane label="已读消息" name="1"></el-tab-pane>
      </el-tabs>
      <div class="table-operate-nav">
        <el-button v-show="activeName !== '1'" @click="markRows">标记为已读</el-button>
        <el-button v-show="activeName !== '1'" @click="markAllAdRead">全部标记为已读</el-button>
      </div>
      <Table
        ref="table"
        v-loading="loading"
        :props="table.props"
        :header="table.header"
        :data="table.data"
        :selected="table.selected"
        selection-type="multiple"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
        @row-click="handleRowClick"
      />
      <pagination
        :currentpage="pager.pageNo"
        :pagesize="pager.pageSize"
        :totalcount="pager.totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </ContentBox>
    <!--详情-->
    <MessageDrawer :show-drawer="showDrawer" :message-model="messageModel" @close="showDrawer = false" />
  </div>
</template>

<script>
import ContentBox from '@/components/common/ContentBox'
import MessageDrawer from './MessageDrawer.vue'

export default {
  components: {
    ContentBox,
    MessageDrawer
  },
  data() {
    return {
      activeName: '2',
      loading: false,
      searchParams: {
        keyword: ''
      },
      selected: [],
      selectedRow: [],
      table: {
        props: {
          border: true,
          'tooltip-effect': 'light',
          'row-style': ({ row }) => {
            return row.readStatus === 1 ? { color: '#ccc' } : { color: '#000' }
          }
        },
        header: [
          {
            label: '消息编号',
            align: 'left',
            prop: 'subOrder',
            'min-width': 80,
            'show-overflow-tooltip': true
          },
          {
            label: '消息标题',
            align: 'left',
            prop: 'statusChangeDesc',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '消息内容',
            align: 'left',
            prop: 'detailDesc',
            'min-width': 150,
            'show-overflow-tooltip': true
          },
          {
            label: '消息时间',
            align: 'left',
            prop: 'createTime',
            'min-width': 80,
            'show-overflow-tooltip': true
          }
        ],
        selected: [],
        data: []
      },
      pager: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0
      },
      showDrawer: false,
      messageModel: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.handleSearch()
      this.$store.dispatch('setShowMessageTip', false)
    },
    handleSearch() {
      this.activeName = '2'
      this.pager.pageNo = 1
      this.pager.pageSize = 10
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      const { pageSize, pageNo } = this.pager
      const filter = { pageNo, pageSize }
      if (this.searchParams.keyword) filter.statusChangeDesc = this.searchParams.keyword
      if (this.activeName !== '2') filter.readStatus = parseInt(this.activeName)
      this.$service
        .getMessagePageList(filter)
        .then((data) => {
          this.loading = false
          this.table.data = data.rows || []
          this.pager.totalCount = data.total || 0
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.pageNo = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.subOrderLogId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter((item) => {
        return item !== targetItem.subOrderLogId
      })
      this.selectedRow = this.selectedRow.filter((item) => {
        return item.subOrderLogId !== targetItem.subOrderLogId
      })
      this.updateTableSelected()
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.subOrderLogId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleTabClick() {
      this.pager.pageNo = 1
      this.fetchData()
    },
    markRows() {
      let ids = []
      this.table.selected.forEach(index => {
        const item = this.table.data[index]
        if (item.readStatus === 0) ids.push(item.subOrderLogId)
      })
      if (ids.length === 0) return
      this.markAsRead(ids).then(res => {
        if (this.activeName === '0') {
          this.pager.pageNo = 1
        }
        this.fetchData()
        this.$nextTick(() => {
          this.table.selected = []
          this.selected = []
          this.selectedRow = []
          this.$refs.table.$refs.table.clearSelection()
        })
      })
    },
    markAsRead(ids) {
      const params = ids
      return this.$service.markMessageAsRead(params).then(res => {
        this.$store.dispatch('getUnreadMsgNum')
      })
    },
    markAllAdRead() {
      this.$service.markAllAsRead().then(res => {
        this.pager.pageNo = 1
        this.fetchData()
        this.$store.dispatch('getUnreadMsgNum')
      })
    },
    handleRowClick(row) {
      this.messageModel = this.cloneDeep(row)
      this.showDrawer = true
      if (row.readStatus === 0) {
        this.markAsRead([row.subOrderLogId])
        row.readStatus = 1
        if (this.activeName === '0') {
          this.pager.pageNo = 1
          this.fetchData()
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.comment
  position relative
  height 100%
  .search-header
    display flex
    flex-direction row
    padding 15px 38px
    margin-bottom 16px
    background #fff
    width 100%
    border-bottom 1px solid #dcdfe6
    box-shadow 0 1px 4px 0 rgba(0, 0, 0, 0.06)
    align-items center
    justify-content space-between
    box-sizing border-box
    .content
      margin-right 10px
      .el-form-item
        margin-bottom 0px
.content-list
  margin 16px
  background #fff
  border none
.table-operate-nav
  margin-bottom 10px
</style>
